import { useTranslation } from "react-i18next";

const Diamond = () => (
  <span className="mx-10 inline-block h-1.5 w-1.5 rotate-45 bg-brass/50" aria-hidden="true" />
);

const Marquee = () => {
  const { t } = useTranslation("common");
  const items = t("marquee", { returnObjects: true });

  return (
    <div
      data-testid="credentials-marquee"
      className="overflow-hidden border-y border-white/[0.06] bg-surface/40 py-4"
    >
      <div className="flex w-max animate-marquee items-center">
        {[...items, ...items].map((item, i) => (
          <span key={i} className="flex items-center whitespace-nowrap">
            <span className="font-serif text-sm italic text-mist/60">{item}</span>
            <Diamond />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
